import { render, staticRenderFns } from "./EmpiModal.vue?vue&type=template&id=2f1396e4&scoped=true"
import script from "./EmpiModal.vue?vue&type=script&lang=js"
export * from "./EmpiModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1396e4",
  null
  
)

export default component.exports